<template>
 <v-container class="v-sheet-main-container content elevation-12">
    <v-toolbar extended flat class="hidden-md-and-up v-toolbar-custom"><!--Design en une ligne pour PC et tablette paysage-->
      <v-toolbar-title class="ma-2">{{ $t('mycontent.title') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu 
        bottom
        left
        transition="slide-x-reverse-transition"
        origin="top right"
      >
        <template v-slot:activator="{ on: menu }">
          <v-tooltip color="rgba(0,0,0,0.2)" left>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn depressed fab small dark v-on="{...tooltip, ...menu}" class="custom-header-btn">
                <v-icon>mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span> Aide contextuelle </span>
          </v-tooltip>
        </template>
        <v-card dark color="menuTooltip" max-height="80vh" class="helpMenu" style="overflow-y:auto;">
          <v-card-text class="body-1 font-weight-regular text-center pb-0" style="color:white!important">
            Vous cherchez vos créations ?<br>elles sont toutes ici !
          </v-card-text>
          <v-card-text class="body-2 text-center" style="color:rgba(255,255,255,0.8)!important">
            Différentes actions s'offrent à vous :
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text class="font-weight-medium text-uppercase text-left pb-0">
            <v-icon class="mr-2">mdi-pause</v-icon>Suspendre le média
          </v-card-text>
          <v-card-text class="body-2 text-left pt-2">
              <span>Mettre sa diffusion en pause sur tous les écrans qui le diffusent.</span>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text class="font-weight-medium text-uppercase text-left pb-0">
            <v-icon class="mr-2">mdi-play</v-icon>Diffuser maintenant
            </v-card-text>
          <v-card-text class="body-2 text-left pt-2">
              <span>Relancer un média suspendu sur les écrans qui le diffusaient.</span>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text class="font-weight-medium text-uppercase text-left pb-0">
            <v-icon class="mr-2">mdi-calendar-month</v-icon>Modifier sa programmation
          </v-card-text>
          <v-card-text class="body-2 text-left pt-2">
              <span>Changer ses dates, jours, heures ou écrans de diffusion.</span>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text class="font-weight-medium text-uppercase text-left pb-0">
            <v-icon class="mr-2">mdi-pencil</v-icon>Modifier le média
          </v-card-text>
          <v-card-text class="body-2 text-left pt-2">
              <span>Changer le contenu et la position des textes, les polices de caractère, les couleurs et/ou les prix affichés sur le média.</span>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text class="font-weight-medium text-uppercase text-left pb-0">
            <v-icon class="mr-2">mdi-trash-can-outline</v-icon>Supprimer le média
          </v-card-text>
          <v-card-text class="body-2 text-left pt-2">
              <span>Supprimer définitivement un média dont vous ne vous servirez plus.</span>
          </v-card-text>
        </v-card>
      </v-menu>
      <template #extension class="d-flex flex-row justify-end">
        <v-tooltip open-delay="600" max-width="250" color="myContent" bottom style="border-radius:8em!important;">
          <template v-slot:activator="{ on }">
            <v-text-field v-on="on" dark
              style="width:100%!important;"
              class="pr-3 pt-1"
              placeholder="Rechercher"
              prepend-inner-icon="mdi-magnify"
              v-model="search"
              :clearable="true"
              clear-icon="mdi-close-circle"
              rounded
              filled
              dense
              :hide-details="true"
            ></v-text-field>
          </template>
          <span> Pour rechercher un média saisissez son nom ou un mot clé. </span>
        </v-tooltip>
        <v-menu  offset-y left
          :close-on-content-click="false"
          :close-on-click="true"
          transition="scale-transition"
          origin="top right"
          min-width="290px"
        >
        <template v-slot:activator="{ on: filter }">
          <v-tooltip color="rgba(0,0,0,0.2)" left>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn depressed fab v-on="{...tooltip, ...filter}" small dark class="">
                <v-icon>mdi-filter</v-icon>
              </v-btn>
            </template>
            <span> Filtres de recherche</span>
          </v-tooltip>
        </template>
          <v-card color="myContent" class="pa-4 elevation-12">
            <v-tooltip open-delay="600" max-width="250" color="myContent" bottom style="border-radius:8em!important;">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-select dark
                    menu-props="auto"
                    item-color="myContent"
                    append-icon="mdi-chevron-down" 
                    style="width:270px!important;"
                    class="mb-2 custom"
                    :items="screenList"
                    v-model="selectedScreen"
                    item-text="server_name"
                    @change="filterFiles"
                    return-object
                    :hide-details="true"
                    rounded
                    filled
                    dense
                  ></v-select>
                </div>
              </template>
              <span>Affiche les médias d'un écran en particulier.</span>
            </v-tooltip>
            <v-tooltip open-delay="600" max-width="250" color="myContent" bottom style="border-radius:8em!important;">
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-select dark
                    menu-props="auto"
                    item-color="myContent"
                    append-icon="mdi-chevron-down"
                    style="width:270px!important"
                    class="custom"
                    :items="contentStatus"
                    v-model="chosenStatus"
                    return-object
                    @change="filterFiles"
                    item-text="name"
                    item-value="id"
                    :hide-details="true"
                    rounded
                    filled
                    dense
                  ></v-select>
                </div>
              </template>
              <span>Affiche les médias avec le statut sélectionné.</span>
            </v-tooltip>
          </v-card>
        </v-menu>
      </template #extension>
    </v-toolbar>
    <v-toolbar flat class="hidden-sm-and-down v-toolbar-custom"><!--Design en deux lignes pour tablette portrait et mobile-->
      <v-toolbar-title class="ma-2">{{ $t('mycontent.title') }}</v-toolbar-title>
      <div class="custom-center">
          <v-tooltip open-delay="600" max-width="250" color="myContent" bottom style="border-radius:8em!important;">
            <template v-slot:activator="{ on }">
              <v-text-field v-on="on" dark
                style="max-width:300px!important;"
                class="px-3 pt-1"
                placeholder="Rechercher"
                prepend-inner-icon="mdi-magnify"
                v-model="search"
                :clearable="true"
                clear-icon="mdi-close-circle"
                rounded
                filled
                dense
                :hide-details="true"
              ></v-text-field>
            </template>
            <span> Pour rechercher un média saisissez son nom ou un mot clé. </span>
          </v-tooltip>
          <v-tooltip open-delay="600" max-width="250" color="myContent" bottom style="border-radius:8em!important;">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-select dark
                  menu-props="auto"
                  item-color="myContent"
                  append-icon="mdi-chevron-down" 
                  style="width:260px!important;"
                  class="px-3 pt-1 custom"
                  :items="screenList"
                  v-model="selectedScreen"
                  item-text="server_name"
                  @change="filterFiles"
                  return-object
                  :hide-details="true"
                  rounded
                  filled
                  dense
                ></v-select>
              </div>
            </template>
            <span>Affiche les médias d'un écran en particulier.</span>
          </v-tooltip>
          <v-tooltip open-delay="600" max-width="250" color="myContent" bottom style="border-radius:8em!important;">
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-select dark
                  :menu-props="{contentClass: 'customSelect'}"
                  color="myContent"
                  item-color="myContent"
                  append-icon="mdi-chevron-down"
                  style="width:270px!important"
                  class="px-3 pt-1 custom"
                  :items="contentStatus"
                  v-model="chosenStatus"
                  return-object
                  @change="filterFiles"
                  item-text="name"
                  item-value="id"
                  :hide-details="true"
                  rounded
                  filled
                  dense

                ></v-select>
              </div>
            </template>
          <span>Affiche les médias avec le statut sélectionné.</span>
        </v-tooltip>
      </div>
      <v-spacer></v-spacer>
      <v-menu 
        bottom
        left
        transition="slide-x-reverse-transition"
        origin="top right"
      >
        <template v-slot:activator="{ on: menu }">
          <v-tooltip color="rgba(0,0,0,0.2)" left>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn depressed fab small dark v-on="{...tooltip, ...menu}" class="custom-header-btn">
                <v-icon>mdi-help-circle</v-icon>
              </v-btn>
            </template>
            <span> Aide contextuelle </span>
          </v-tooltip>
        </template>
        <v-card dark color="menuTooltip" max-height="80vh" class="helpMenu" style="overflow-y:auto;">
          <v-card-text class="body-1 font-weight-regular text-center pb-0" style="color:white!important">
            Vous cherchez vos créations ?<br>elles sont toutes ici !
          </v-card-text>
          <v-card-text class="body-2 text-center" style="color:rgba(255,255,255,0.8)!important">
            Différentes actions s'offrent à vous :
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text class="font-weight-medium text-uppercase text-left pb-0">
            <v-icon class="mr-2">mdi-pause</v-icon>Suspendre le média
          </v-card-text>
          <v-card-text class="body-2 text-left pt-2">
              <span>Mettre sa diffusion en pause sur tous les écrans qui le diffusent.</span>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text class="font-weight-medium text-uppercase text-left pb-0">
            <v-icon class="mr-2">mdi-play</v-icon>Diffuser maintenant
            </v-card-text>
          <v-card-text class="body-2 text-left pt-2">
              <span>Relancer un média suspendu sur les écrans qui le diffusaient.</span>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text class="font-weight-medium text-uppercase text-left pb-0">
            <v-icon class="mr-2">mdi-calendar-month</v-icon>Modifier sa programmation
          </v-card-text>
          <v-card-text class="body-2 text-left pt-2">
              <span>Changer ses dates, jours, heures ou écrans de diffusion.</span>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text class="font-weight-medium text-uppercase text-left pb-0">
            <v-icon class="mr-2">mdi-pencil</v-icon>Modifier le média
          </v-card-text>
          <v-card-text class="body-2 text-left pt-2">
              <span>Changer le contenu et la position des textes, les polices de caractère, les couleurs et/ou les prix affichés sur le média.</span>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text class="font-weight-medium text-uppercase text-left pb-0">
            <v-icon class="mr-2">mdi-trash-can-outline</v-icon>Supprimer le média
          </v-card-text>
          <v-card-text class="body-2 text-left pt-2">
              <span>Supprimer définitivement un média dont vous ne vous servirez plus.</span>
          </v-card-text>
        </v-card>
      </v-menu>
    </v-toolbar>
    <v-sheet id="my-content-wrapper" style="position:relative;overflow:hidden;" class="fill-height border-main-content elevation-3 scrollMyContent">
      <v-container style="position:relative;height:100%;">
        <v-data-iterator
          hide-default-footer
          hide-default-header
          row
          wrap
          :no-results-text="noResultText"
          :search="search"
          :items="filesToDisplay"
          :page.sync="page"
          :items-per-page.sync="itemsPerPage"
          v-if="filesToDisplay.length>0"
          style="position:relative;height:100%;"
          transition="scale-transition"
        >
          <template v-slot:default="props">
            <div style="height:calc(100% + -56px);width:100%;overflow-y:auto;">
              <v-row no-gutters class="rowIterator justify-start pr-3" style="padding-top:14px;">
                <v-col v-for="item in props.items" :key="item.fileProps.id" class="col-auto media-card-wrapper">
                  <media-card v-bind:fileToDisplay="item" />
                </v-col>
              </v-row>
            </div>
            <div class="mx-auto pa-2" style="position:absolute;bottom:0px;width:100%;background-color:rgba(var(--editProg-rgb),.1);">
              <v-btn x-small rounded depressed style="height:auto;padding:0px;" @click="formerPage" :disabled="page === 1" :style="{opacity: leftButtonOpacity}">
                <v-icon class="pa-2" medium>mdi-chevron-left</v-icon>
              </v-btn>
              <span class="pa-2">
                Page {{ page }} / {{ numberOfPages }}
              </span>
              <v-btn x-small rounded depressed style="height:auto;padding:0px;" @click="nextPage" :disabled="page === numberOfPages" :style="{opacity: rightButtonOpacity}">
                <v-icon class="pa-2" medium>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-iterator>
        <div class="d-flex flex-column align-center justify-center" style="height:100%;"  v-if="filesToDisplay.length === 0 && doneFecthing">
          <h3 class="title font-italic font-weight-regular" style="color:var(--v-primary-base);!important"> {{ noResultText }} </h3>
          <img class="mx-auto" style="height:274px;width:274px;" src="@/assets/images/illu_noResult_mycontent.png">
        </div>
        <v-dialog v-model="dialogConfirmRemove" persistent overlay-color="dialog" overlay-opacity="0.8" max-width="350px" transition="scale-transition">
          <v-card class="pa-4">
            <v-card-text class="mt-3 title font-italic" style="color:var(--v-primary-base);">
              {{ $t('userMessage.media-delete-title') }}
            </v-card-text>
            <v-tooltip open-delay="800ms" bottom color="rgba(var(--editMedia-rgb),1)">
              <template v-slot:activator="{ on }">
                <img class="mb-2" style="height:274px;width:274px;" src="@/assets/images/illu_delete_mycontent.png" v-on="on">
              </template>
              <span>Illustration : Ivan Haidutski</span>
            </v-tooltip>
            <v-card-text class="body-2" style="color:var(--v-primary-base);">
              {{ $t('userMessage.media-delete-message') }}
            </v-card-text>
            <v-card-text class="font-weight-medium" style="color:var(--v-primary-base);"><v-icon class="mr-1">mdi-alert-circle-outline</v-icon>
              {{ $t('userMessage.media-delete-warning') }}
            </v-card-text>
            <v-card-actions>
              <v-btn large rounded depressed text style="width:45%" @click="dialogConfirmRemove = false">{{ $t('global.cancel') }}</v-btn>
              <v-spacer></v-spacer>
              <v-btn large outlined rounded style="width:45%" class="custom-valid-btn edit-media" @click="removeImage">{{ $t('global.confirm') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-snackbar @click.native="snackbarUploadSuccessful = false" v-model="snackbarUploadSuccessful" :timeout="timeoutDuration">
          {{ $t('global.uploadSuccessful') }}
        </v-snackbar>
        <v-snackbar @click.native="snackbarRemoveSuccessful = true" v-model="snackbarRemoveSuccessful" :timeout="timeoutDuration">
          {{ $t('userMessage.media-delete-success') }}
        </v-snackbar>
        <v-snackbar @click.native="snackbarRemoveFailed = false" v-model="snackbarRemoveFailed" :timeout="timeoutDuration">
          {{ $t('userMessage.media-delete-failed') }}
        </v-snackbar>
        <v-snackbar @click.native="snackbarEditSuccessful = false" v-model="snackbarEditSuccessful" :timeout="timeoutDuration">
          Le média a bien été modifié
        </v-snackbar>
        <v-snackbar @click.native="snackbarSuspend = false" v-model="snackbarSuspend" :timeout="timeoutDuration">
          Le média a été suspendu
        </v-snackbar>
      </v-container>
    </v-sheet>
    <v-dialog v-model="dialogWip" persistent overlay-color="dialog" overlay-opacity="0.8" max-width="350px" transition="scale-transition">
      <WipDialog />
    </v-dialog>
    <modals-container @close="showSnackbars"/>
  </v-container>
</template>

<script>
import FtpService from '@/services/FTPService'
import MediaCard from './Subcomponents/MediaCardComponent'
import SuspendMediaModal from './Subcomponents/SuspendMediaModal'
import ContentSettingEditModal from './Subcomponents/ContentSettingsEditModal'
import StartMediaBroadcastModal from './Subcomponents/StartBroadcastModal'
import WipDialog from './Subcomponents/WipDialog'
export default {
  data () {
    return {
      screenList: [],
      selectedScreen: {name: this.$i18n.t('mycontent.every-screen'), server_name: this.$i18n.t('mycontent.every-screen')},
      contentStatus: [
        {id: 0, name: this.$i18n.t('contentStatus.all')},
        {id: 1, name: this.$i18n.t('contentStatus.ongoing')},
        {id: 2, name: this.$i18n.t('contentStatus.upcoming')},
        {id: 3, name: this.$i18n.t('contentStatus.ongoing-and-upcoming')},
        {id: 4, name: this.$i18n.t('contentStatus.suspended')},
        {id: 5, name: this.$i18n.t('contentStatus.over')}
      ],
      chosenStatus: { id: 3, name: this.$i18n.t('contentStatus.ongoing-and-upcoming') },
      suspendedFiles: [],
      ongoingFiles: [],
      upcomingFiles: [],
      doneFiles: [],
      filesToDisplay: [],
      itemsPerPage: 12,
      page: 1,
      leftButtonOpacity: 0,
      rightButtonOpacity: 0,
      timeoutDuration: 4000,
      snackbarUploadSuccessful: false,
      snackbarRemoveSuccessful: false,
      snackbarRemoveFailed: false,
      dialogConfirmRemove: false,
      fileToRemove: null,
      search: '',
      noResultText: 'Aucun résultat',
      doneFecthing: false,
      snackbarEditSuccessful: false,
      isOldFile: false,
      dialogWip: false,
      menuprops: {contentClass: 'customSelect'},
      fileToSuspend: null,
      snackbarSuspend: false
    }
  },
  components: {
    MediaCard,
    SuspendMediaModal,
    StartMediaBroadcastModal,
    ContentSettingEditModal,
    WipDialog
  },
  async mounted () {
    this.$store.dispatch('setIsLoggedIn', true)
    this.snackbarEditSuccessful = this.$store.state.editSuccessful
    this.snackbarUploadSuccessful = this.$store.state.uploadSuccessful
    this.$store.dispatch('setFile', null)
    this.$store.dispatch('setPixabayImageID', 0)
    this.$store.dispatch('setPixabayImageURL', null)
    this.$store.dispatch('setSelectedScreen', null)
    this.$store.dispatch('setEditSuccessful', false)
    this.$store.dispatch('setUploadSuccessful', false)
    
    var date = new Date()
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    if (month < 10) {
      month = '0' + month.toString()
    }
    var day = date.getDate()
    if (day < 10) {
      day = '0' + day.toString()
    }
    var today = year.toString() + month.toString() + day.toString()
    var screens = []
    this.screenList.push({name: this.$i18n.t('mycontent.every-screen'), server_name: this.$i18n.t('mycontent.every-screen')})
    if (this.$store.state.selectedSite.SitNom === "Tous") {
      this.$store.state.user.sites.forEach(site => {
        site.screens.forEach(screen => {
          this.screenList.push(screen)
          screens.push(screen)
        })
      })
      const response = await FtpService.fetchContentByUser({
        userID: this.$store.state.user.id
      })
      if (this.screenList.length > 20) {
        this.menuprops = {contentClass: 'customSelect customSelectLong', auto: true}
      }
      var removeDuplicates = []
      response.data.files.forEach(element => {
        if (removeDuplicates.includes(element.id)) {
          return
        }
        removeDuplicates.push(element.id)
        element.isOldFile = false
        var d = element.date_debut.substring(0,4).toString() + element.date_debut.substring(5,7).toString() + element.date_debut.substring(8).toString()
        var f = element.date_fin ? element.date_fin.substring(0,4).toString() + element.date_fin.substring(5,7).toString() + element.date_fin.substring(8).toString() : null
        if (!element.suspendu) {
          this.suspendedFiles.push({
            name: element.titre,
            fileProps: element,
            class: 'suspended',
            status: 'Suspendu',
            icon: 'mdi-television-pause'
          })
        } else if (!d && !f) {
          this.ongoingFiles.push({
            name: element.titre,
            fileProps: element,
            class: 'ongoing',
            status: 'En diffusion',
            icon: 'mdi-television-play'})
        } else if (d && !f) {
          if (parseInt(d, 10) <= parseInt(today, 10)) {
            this.ongoingFiles.push({
              name: element.titre,
              fileProps: element,
              class: 'ongoing',
              status: 'En diffusion',
              icon: 'mdi-television-play'})
          } else {
            this.upcomingFiles.push({
              name: element.titre,
              fileProps: element,
              class: 'programmed',
              status: 'Programmé',
              icon: 'mdi-calendar-check-outline'})
          }
        } else if (!d && f) {
          if (parseInt(f, 10) <= parseInt(today, 10)) {
            this.ongoingFiles.push({
              name: element.titre,
              fileProps: element,
              class: 'ongoing',
              status: 'En diffusion',
              icon: 'mdi-television-play'})
          } else {
            this.doneFiles.push({
              name: element.titre,
              fileProps: element,
              class: 'done',
              status: 'Terminé',
              icon: 'mdi-calendar-remove-outline'})
          }
        } else {
          if (parseInt(d, 10) > parseInt(today, 10)) {
            this.upcomingFiles.push({
              name: element.titre,
              fileProps: element,
              class: 'programmed',
              status: 'Programmé',
              icon: 'mdi-calendar-check-outline'})
          } else if (parseInt(f, 10) < parseInt(today, 10)) {
            this.doneFiles.push({
              name: element.titre,
              fileProps: element,
              class: 'done',
              status: 'Terminé',
              icon: 'mdi-calendar-remove-outline'})
          } else {
            this.ongoingFiles.push({
              name: element.titre,
              fileProps: element,
              class: 'ongoing',
              status: 'En diffusion',
              icon: 'mdi-television-play'})
          }
        }
      })
      this.filesToDisplay = this.ongoingFiles.concat(this.upcomingFiles)
      this.doneFecthing = true
    } else {
      this.$store.state.selectedSite.screens.forEach(element => {
        this.screenList.push(element)
        screens.push(element)
      })
      var response
      if (this.$store.state.user.id === 275) {
        response = await FtpService.fetchContentByUserAndSite({
          userID: this.$store.state.user.id,
          site: this.$store.state.selectedSite.SitNom
        })
      } else {
        response = await FtpService.fetchContent({
          site: this.$store.state.selectedSite.SitNom,
          screen: screens
        })
      }

      const response2 = await FtpService.fetchOldContent({
        site: this.$store.state.selectedSite.SitNom,
        screen: screens
      })
    
      var newMediaName = []
      var oldMedia = []
      response.data.files.forEach(media => {
        newMediaName.push(media.media_name)
      })

      response2.data.medias.forEach(media => {
        var nameNoAvi = media.name.split('.')[0] + '.' + media.name.split('.')[1]      
        if (!newMediaName.includes(nameNoAvi)) {
          oldMedia.push(media)
        }
      })
     
      
      const groupBy = key => array =>
        array.reduce((objectsByKeyValue, obj) => {
          const value = obj[key]
          objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj)
          return objectsByKeyValue
        }, {})

      
      const groupByName = groupBy('name')
      var oldMediaByName = groupByName(oldMedia)
      oldMediaByName = Object.values(oldMediaByName)
      var removeDuplicates = []
      //  trier video et image
      response.data.files.forEach(element => {
        if (removeDuplicates.includes(element.id)) {
          return
        }
        removeDuplicates.push(element.id)
        element.isOldFile = false
        var d = element.date_debut.substring(0,4).toString() + element.date_debut.substring(5,7).toString() + element.date_debut.substring(8).toString()
        var f = element.date_fin ? element.date_fin.substring(0,4).toString() + element.date_fin.substring(5,7).toString() + element.date_fin.substring(8).toString() : null
        if (!element.suspendu) {
          this.suspendedFiles.push({
            name: element.titre,
            fileProps: element,
            class: 'suspended',
            status: 'Suspendu',
            icon: 'mdi-television-pause'
          })
        } else if (!d && !f) {
          this.ongoingFiles.push({
            name: element.titre,
            fileProps: element,
            class: 'ongoing',
            status: 'En diffusion',
            icon: 'mdi-television-play'})
        } else if (d && !f) {
          if (parseInt(d, 10) <= parseInt(today, 10)) {
            this.ongoingFiles.push({
              name: element.titre,
              fileProps: element,
              class: 'ongoing',
              status: 'En diffusion',
              icon: 'mdi-television-play'})
          } else {
            this.upcomingFiles.push({
              name: element.titre,
              fileProps: element,
              class: 'programmed',
              status: 'Programmé',
              icon: 'mdi-calendar-check-outline'})
          }
        } else if (!d && f) {
          if (parseInt(f, 10) <= parseInt(today, 10)) {
            this.ongoingFiles.push({
              name: element.titre,
              fileProps: element,
              class: 'ongoing',
              status: 'En diffusion',
              icon: 'mdi-television-play'})
          } else {
            this.doneFiles.push({
              name: element.titre,
              fileProps: element,
              class: 'done',
              status: 'Terminé',
              icon: 'mdi-calendar-remove-outline'})
          }
        } else {
          if (parseInt(d, 10) > parseInt(today, 10)) {
            this.upcomingFiles.push({
              name: element.titre,
              fileProps: element,
              class: 'programmed',
              status: 'Programmé',
              icon: 'mdi-calendar-check-outline'})
          } else if (parseInt(f, 10) < parseInt(today, 10)) {
            this.doneFiles.push({
              name: element.titre,
              fileProps: element,
              class: 'done',
              status: 'Terminé',
              icon: 'mdi-calendar-remove-outline'})
          } else {
            this.ongoingFiles.push({
              name: element.titre,
              fileProps: element,
              class: 'ongoing',
              status: 'En diffusion',
              icon: 'mdi-television-play'})
          }
        }
      })
      oldMediaByName.forEach(element => {
        var name = element[0].name
        element.id = element[0].name
        element.isOldFile = true
        var d = name.includes('__d') ? name.split('__d')[1].substring(0,8) : null
        var f = name.includes('__f') ? name.split('__f')[1].substring(0,8) : null
        if (!d && !f) {
          this.ongoingFiles.push({
            name: '',
            fileProps: element,
            class: 'ongoing',
            status: 'En diffusion',
            icon: 'mdi-television-play'})
        } else if (d && !f) {
          if (parseInt(d, 10) <= parseInt(today, 10)) {
            this.ongoingFiles.push({
              name: '',
              fileProps: element,
              class: 'ongoing',
              status: 'En diffusion',
              icon: 'mdi-television-play'})
          } else {
            this.upcomingFiles.push({
              name: '',
              fileProps: element,
              class: 'programmed',
              status: 'Programmé',
              icon: 'mdi-calendar-check-outline'})
          }
        } else if (!d && f) {
          if (parseInt(f, 10) <= parseInt(today, 10)) {
            this.ongoingFiles.push({
              name: '',
              fileProps: element,
              class: 'ongoing',
              status: 'En diffusion',
              icon: 'mdi-television-play'})
          } else {
            this.doneFiles.push({
              name: element.titre,
              fileProps: element,
              class: 'done',
              status: 'Terminé',
              icon: 'mdi-calendar-remove-outline'})
          }
        } else {
          if (parseInt(d, 10) > parseInt(today, 10)) {
            this.upcomingFiles.push({
              name: '',
              fileProps: element,
              class: 'programmed',
              status: 'Programmé',
              icon: 'mdi-calendar-check-outline'})
          } else if (parseInt(f, 10) < parseInt(today, 10)) {
            this.doneFiles.push({
              name: '',
              fileProps: element,
              class: 'done',
              status: 'Terminé',
              icon: 'mdi-calendar-remove-outline'})
          } else {
            this.ongoingFiles.push({
              name: '',
              fileProps: element,
              class: 'ongoing',
              status: 'En diffusion',
              icon: 'mdi-television-play'})
          }
        }
      })
      this.filesToDisplay = this.ongoingFiles.concat(this.upcomingFiles)
      this.doneFecthing = true
    }  
  },
  methods: {
    nextPage () {
      if (this.page + 1 <= this.numberOfPages) {
        this.page += 1
      }
    },
    formerPage () {
      if (this.page - 1 >= 1) {
        this.page -= 1
      }
    },
    filterFiles (){
      if (this.selectedScreen.server_name === this.$i18n.t('mycontent.every-screen')) {
        this.$store.dispatch('setSelectedScreen', null)
      } else {
        this.$store.dispatch('setSelectedScreen', this.selectedScreen)
      }
      if (this.chosenStatus.id === 0) {
        this.filesToDisplay = this.ongoingFiles.concat(this.upcomingFiles)
        this.filesToDisplay = this.filesToDisplay.concat(this.doneFiles)
        this.filesToDisplay = this.filesToDisplay.concat(this.suspendedFiles)
      } else if (this.chosenStatus.id === 1) {
        this.filesToDisplay = this.ongoingFiles
      } else if (this.chosenStatus.id === 2) {
        this.filesToDisplay = this.upcomingFiles
      } else if (this.chosenStatus.id === 3) {
        this.filesToDisplay = this.ongoingFiles.concat(this.upcomingFiles)
      } else if (this.chosenStatus.id === 4) {
        this.filesToDisplay = this.suspendedFiles
      } else {
        this.filesToDisplay = this.doneFiles
      }

      if (this.selectedScreen.server_name !== this.$i18n.t('mycontent.every-screen')) {
        this.filesToDisplay = this.filesToDisplay.filter((element) => {
          if (element.fileProps.ecrans !== undefined) {
            return element.fileProps.ecrans.includes(this.selectedScreen.server_name)
          } else {
            if (this.selectedScreen.server_name === 'Ligne de caisse') {
              for (let i = 0; i<element.fileProps.length; i++) {
                if (element.fileProps[i].path.includes('transition_local')){
                  return true
                }
              }
              return false
            } else {
              for (let i = 0; i<element.fileProps.length; i++) {
                if (element.fileProps[i].path.includes(this.selectedScreen.server_name)){
                  return true
                }
              }
              return false
            }
          }   
        })
      }
    },
    showSnackbars () {
      if (this.$store.state.editSuccessful === true){
        this.snackbarEditSuccessful = true
        this.$store.dispatch('setEditSuccessful', false)
      }
    },
    suspendMedia (fileToSuspend) {
      this.fileToSuspend = fileToSuspend
      this.$modal.show(SuspendMediaModal, {file: fileToSuspend}, {clickToClose: false, adaptive: true, transition: 'scale-transition', maxWidth: 558, height: 'auto'})
    },
    startMediaBroadcast (fileToBroadcast) {
      this.$modal.show(StartMediaBroadcastModal, {file: fileToBroadcast}, {clickToClose: false, adaptive: true, transition: 'scale-transition', maxWidth: 558, height: 'auto'})
    },
    confirmRemove (file, isOldFile) {
      this.fileToRemove = file
      this.dialogConfirmRemove = true
      this.isOldFile = isOldFile
    },
    async refreshTableAfterSuspension (){
      this.snackbarSuspend = true
      this.suspendedFiles.push(this.fileToSuspend)
      var suspendedFile = this.fileToSuspend
      this.filesToDisplay = this.filesToDisplay.filter(function (element) {
        return element.fileProps.id !== suspendedFile.id
      })
    },
    async removeImage () {
      if (!this.isOldFile) {
        if (this.$store.state.user.id === 295 && this.$store.state.selectedSite.SitNom.includes('Tous')) {
          const response = await FtpService.removeImageFromCultura({
            filename: this.fileToRemove.media_name,
            user: this.$store.state.user.id
          })
          if (response) {
            if (response.status === 200) {
              this.dialogConfirmRemove = false
              this.snackbarRemoveSuccessful = true
            } else {
              this.snackbarRemoveFailed = true
            }
          }
          let fileToRemove = this.fileToRemove
          this.filesToDisplay = this.filesToDisplay.filter(function (element) {
            return element.fileProps.media_name !== fileToRemove.media_name
          })
        } else {
          const response = await FtpService.removeImage({
            filename: this.fileToRemove.media_name,
            id: this.fileToRemove.id,
            site: this.$store.state.selectedSite.SitNom,
            user: this.$store.state.user.id
          })
          if (response) {
            if (response.status === 200) {
              this.dialogConfirmRemove = false
              this.snackbarRemoveSuccessful = true
            } else {
              this.snackbarRemoveFailed = true
            }
          }
          let fileToRemove = this.fileToRemove
          this.filesToDisplay = this.filesToDisplay.filter(function (element) {
            return element.fileProps.media_name !== fileToRemove.media_name
          })
        }    
      } else {
        var paths = []
        for (let i = 0; i < this.fileToRemove.length; i++) {
          paths.push(this.fileToRemove[i].path)
        }
        const response = await FtpService.removeOldFile({
          paths: paths
        })
        if (response) {
          if (response.status === 200) {
            this.dialogConfirmRemove = false
            this.snackbarRemoveSuccessful = true
          } else {
            this.snackbarRemoveFailed = true
          }
        }
        let fileToRemove = this.fileToRemove
        this.filesToDisplay = this.filesToDisplay.filter(function (element) {
          return element.fileProps.id !== fileToRemove.id
        })
      }
    },
    editSettings (fileProps, isOldFile) {
      this.$modal.show(ContentSettingEditModal, {file: fileProps, from: 'content', isOldFile: isOldFile}, {clickToClose: false, transition: 'scale-transition', adaptive: true, maxWidth: 560, height: '80%'})
    },
    editMedia (fileProps) {
      this.dialogWip = true
    }, 
    closeWIPDialog () {
      this.dialogWip = false
    }
  },
  computed: {
    numberOfPages () {
      return Math.ceil(this.filesToDisplay.length / this.itemsPerPage)
    }
  },
  watch: {
    page: function () {
      this.leftButtonOpacity = this.page === 1 ? 0 : 1
      this.rightButtonOpacity = this.page === this.numberOfPages ? 0 : 1
    },
    numberOfPages: function () {
      this.rightButtonOpacity = this.numberOfPages > 1 ? 1 : 0
    }
  }
}
</script>

<style scoped>
.rowIterator {
  height: 694px;
}
</style>
